import { render, staticRenderFns } from "./SurveyPageWrapper.vue?vue&type=template&id=3beb6974&"
import script from "./SurveyPageWrapper.vue?vue&type=script&lang=ts&"
export * from "./SurveyPageWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPageWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports